import { AuthPage } from '../../../src/components/pages/auth';

export const ForgotPassword = () => {
  return <AuthPage type='forgotPassword' />;
};
